import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';

import { TimezoneService } from '../services/timezone.service';

@Pipe({
  name: 'lexDate',
  standalone: false,
})
export class LexDatePipe implements PipeTransform {
  static readonly FORMAT_MAP = {
    short: 'DD-MMM-YYYY',
    long: 'DD-MMM-YYYY HH:mm:ss',
    xiShort: 'MM/DD/YYYY',
    xiLong: 'MM/DD/YYYY HH:mm:ss',
    xiLong12: 'MM/DD/YYYY [at] hh:mm A',
  };

  constructor(private timezoneService: TimezoneService) {}

  transform(value: any, type: keyof typeof LexDatePipe.FORMAT_MAP | string = 'short'): any {
    if (value) {
      const format = LexDatePipe.FORMAT_MAP[type] ?? type;
      const convertedValue = isNaN(+value) ? value : +value;
      return moment.tz(convertedValue, this.timezoneService.timezone).format(format);
    }
  }
}
